import { Page } from './shared/page/page.config';

export const ROUTES = {
  defaultPage: Page.CaList,
  login: 'login',
  passportCode: 'passportCode',
};
